import Callout from '_components/UI/Callout';
import Button from '@components/ui/Button';
import { useTranslation } from 'next-i18next';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import MiniProductStrip from '_components/MiniProductStrip';
import { AlgonomyPlacement } from '@components/global/Recommendations/Loader';
import { useLocale } from '@hooks/useLocale';

import styles from './ProductNotInStockSection.module.scss';

interface ProductNotInStockSectionProps {
  breadcrumbs: MecProduct['breadcrumbs'];
  recommendations: AlgonomyPlacement[];
}

const ProductNotInStockSection = ({
  breadcrumbs,
  recommendations,
}: ProductNotInStockSectionProps) => {
  const outOfStockRecommendations = recommendations.find(
    (item) => item.name === 'item_page.product0_rr'
  );

  const { t } = useTranslation(['pdp']);
  const locale = useLocale();

  const breadcrumbPath =
    breadcrumbs?.[breadcrumbs.length - 1]?.path?.replace(/\/$/, '') || '';

  return (
    <div className={styles.stockMessage}>
      <Callout classNames={styles.outOfStockAlert}>
        <span>{t('product.not.available')}</span>
      </Callout>
      {outOfStockRecommendations && (
        <div className={styles.outOfStockRecommendations}>
          <MiniProductStrip placement={outOfStockRecommendations} />
        </div>
      )}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Button
          href={`/${locale}${breadcrumbPath}`}
          label={
            <span>
              <span>
                {t('product.not.available.button.new').toLocaleUpperCase(
                  locale
                )}
              </span>
              {` ${breadcrumbs[breadcrumbs.length - 1]?.name.toLocaleUpperCase(
                locale
              )}`}
            </span>
          }
          variant="secondary"
          size="large"
          className={styles.outOfStockButton}
        />
      )}
    </div>
  );
};

export default ProductNotInStockSection;
